module.exports = __webpack_public_path__ + "static/media/icon-fully-customizable.cc099cea.svg";